import React, { useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
import illustration from "assets/img/auth/auth.png";
import logo from "assets/img/auth/ejournal-logo.png";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { Adminlogin } from "api/authservice";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function SignIn() {
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailRef = useRef();
  const passRef = useRef();

  const [api, contextHolder] = notification.useNotification();

  const handleClick = () => setShow(!show);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token"); 

    if (token) {
      navigate("/admin/dashboard"); 
    }
  }, []);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message,
      description,
      duration: 2, // مدت نمایش نوتیفیکیشن به ثانیه
      showProgress: true,
    });
  };

  const handleSigninClick = async () => {
    const email = emailRef.current.value;
    const password = passRef.current.value;

    setLoading(true);

    try {
      const response = await Adminlogin({ email, password });

      if (response.error) {
        openNotificationWithIcon("error", "Login Failed!", "Please check your credentials and try again.");
      } else {
        openNotificationWithIcon("success", "Login Successful!", "You are now logged in.");
        setTimeout(() => {
          window.location.href = "/admin/cartable";
        }, 1500);
      }
    } catch (error) {
      openNotificationWithIcon("error", "Error!", "Something went wrong. Please try again.");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000); // هم‌زمان با پایان نوتیفیکیشن
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration} logo={logo} logoLink='https://journal.rhc.ac.ir/'>
      {contextHolder}
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w='100%'
        mx={{ base: "auto", lg: "0px" }}
        me='auto'
        h='100%'
        alignItems='start'
        justifyContent='center'
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection='column'
      >
        <Box me='auto'>
          <Heading color={textColor} fontSize='36px' mb='10px'>
            Sign In
          </Heading>
        </Box>
        <Flex
          zIndex='2'
          direction='column'
          w={{ base: "100%", md: "420px" }}
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: "auto", lg: "unset" }}
          me='auto'
          mb={{ base: "20px", md: "auto" }}
        >
          <Flex align='center' mb='25px'>
            <HSeparator />
            <HSeparator />
          </Flex>
          <FormControl>
            <FormLabel
              display='flex'
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              mb='8px'>
              Email<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              variant='auth'
              fontSize='sm'
              type='email'
              placeholder='mail@example.com'
              mb='24px'
              fontWeight='500'
              size='lg'
              ref={emailRef}
            />
            <FormLabel
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              display='flex'>
              Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size='md'>
              <Input
                isRequired={true}
                fontSize='sm'
                placeholder='Min. 8 characters'
                mb='24px'
                size='lg'
                type={show ? "text" : "password"}
                variant='auth'
                ref={passRef}
              />
              <InputRightElement display='flex' alignItems='center' mt='4px'>
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent='space-between' align='center' mb='24px'>
              <FormControl display='flex' alignItems='center'>
                <Checkbox
                  id='remember-login'
                  colorScheme='brandScheme'
                  me='10px'
                />
                <FormLabel
                  htmlFor='remember-login'
                  mb='0'
                  fontWeight='normal'
                  color={textColor}
                  fontSize='sm'>
                  Keep me logged in
                </FormLabel>
              </FormControl>
              <NavLink to='/auth/forgot-password'>
                <Text
                  color={textColorBrand}
                  fontSize='sm'
                  w='124px'
                  fontWeight='500'>
                  Forgot password?
                </Text>
              </NavLink>
            </Flex>
            <Button
              isLoading={loading}
              loadingText="Signing in..."
              w="100%"
              h="50px"
              fontSize="sm"
              fontWeight="500"
              onClick={handleSigninClick}
              mb="24px"
              isDisabled={loading}
              bg="brand.500"
              color="white"
              _hover={{
                bg: 'brand.600', // 
                _disabled: {
                  bg: 'brand.500', 
                  cursor: 'not-allowed',
                }
              }}
            >
              Sign In
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
